<script>
import GoogleMapLoader from './GoogleMapLoader.vue'
import GoogleMapMarker from './GoogleMapMarker'

const DEFAUT_ZOOM = 13
const defaultCenter = { lat: 57.15012167663551, lng: -2.0954994863181207 }

export default {
  name: 'MapDestination',
  components: {
    GoogleMapLoader,
    GoogleMapMarker,
  },
  props: {
    center: {
      type: Object,
      default: () => defaultCenter,
    },
    google: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      uid: Date.now(),
      message: 'Double click to select your destination point on the map',
      map: null,
      latLng: null,
      mapConfig: {
        zoom: DEFAUT_ZOOM,
        disableDefaultUI: true,
        zoomControl: false,
        center: this.center,
        disableDoubleClickZoom: true,
      },
      marker: null,
      showError: false,
      selectedAddress: '',
    }
  },
  methods: {
    getSelectedAddress(result) {
      if (!result.showError) {
        this.message = result.address
        this.selectedAddress = result.address
      } else {
        this.showError = true
      }
    },
    loading(value) {
      this.isLoading = value
    },
    setSelectedDestionation() {
      this.$emit('setSelectedDestionation', this.selectedAddress)
    },
    backToMain() {
      this.$emit('showForm')
    },
  },
}
</script>

<template>
  <div class="card shadow mx-auto max-width-4 bg-widget-primary">
    <div class="card-body px-lg-3 text-left">
      <div>
        <b-col cols="24">
          <b-button
            variant="link"
            @click="backToMain"
          >
            &lt; Back
          </b-button>
        </b-col>
      </div>
      <div class="text-center">
        <p
          class="details mb-3 mt-1"
          :class="{ 'form-error': showError }"
        >
          {{ showError ? 'Cannot get the selected position location' : message }}
        </p>
      </div>
      <div>
        <GoogleMapLoader
          :google="google"
          :map-config="mapConfig"
        >
          <template slot-scope="{ map }">
            <GoogleMapMarker
              :google="google"
              :map="map"
              @double-click="getSelectedAddress"
            ></GoogleMapMarker>
          </template>
        </GoogleMapLoader>
      </div>
      <div>
        <b-button
          class="full-btn mt-3 mb-1"
          :disabled="!selectedAddress || isLoading"
          @click="setSelectedDestionation()"
        >
          <span v-if="!isLoading">
            Use as destination
            <svg-icon
              v-if="$whitelabel.brand == 'lochlomond'"
              class="arrow-right-find"
              name="forward"
            ></svg-icon>
          </span>
          <b-spinner
            v-if="isLoading"
            type="grow"
            label="Spinning"
            style="width: 24px; height: 24px"
            class="app-spinner-white"
          ></b-spinner>
        </b-button>
      </div>
    </div>
  </div>
</template>
